import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { CombinedReducersType } from "@redux/reducer";
import {
  Footer,
  LinkNavigation,
  LinkNavigationGroup
} from "@common/DynamicUikit";
import { isUQHK } from "@util/country";
import { replacePlaceholder } from "@util/helpers";
import { useParams } from "react-router-dom";
import { LANGUAGE } from "@type/index";

const PublicFooter = () => {
  const { t } = useTranslation();
  const { language } = useParams();
  const { brand_name, region, isApp } = useSelector(
    (store: CombinedReducersType) => store.config
  );

  const handleSwitchLanguage = (lang: string) => {
    if (lang === language) {
      return;
    }
    if (lang === LANGUAGE.ZHHK) {
      const url = replacePlaceholder(window.location.href, {
        en_GB: LANGUAGE.ZHHK
      });
      window.location.replace(url);
    } else {
      const url = replacePlaceholder(window.location.href, {
        zh_HK: LANGUAGE.ENGB
      });
      window.location.replace(url);
    }
  };

  // Only UQHK has switch language icon, and it should be hiden on APP webview
  return isUQHK(brand_name, region) && !isApp ? (
    <Footer
      copyrightRow={t("text_copyright")}
      footerLinksContainer={
        <LinkNavigationGroup
          variant="horizontal"
          labelId={t("text_styling_book_header_title")}
        >
          <LinkNavigation
            element="button"
            onClick={() => handleSwitchLanguage(LANGUAGE.ZHHK)}
            selected={language === LANGUAGE.ZHHK}
          >
            {t("text_locale_hk_zh")}
          </LinkNavigation>
          <LinkNavigation
            element="button"
            onClick={() => handleSwitchLanguage(LANGUAGE.ENGB)}
            selected={language === LANGUAGE.ENGB}
          >
            {t("text_locale_en")}
          </LinkNavigation>
        </LinkNavigationGroup>
      }
    />
  ) : (
    <Footer copyrightRow={t("text_copyright")} />
  );
};

export default PublicFooter;
